/**
 * Convert Google Drive folder ID to full URL
 * @param folderId - Google Drive folder ID (e.g., "1QfkIPTW6ebTlSptm4kqKBvxcOk9fAs4o")
 * @returns Full Google Drive URL or null if folderId is empty
 */
export const buildGoogleDriveFolderUrl = (folderId: string | null | undefined): string | null => {
  if (!folderId || folderId.trim() === '') {
    return null;
  }
  return `https://drive.google.com/drive/folders/${folderId.trim()}`;
};
